import { useMemo } from 'react';
import { ethers } from 'ethers';
import { useWallet } from '../context/WalletContext';
import { CONTRACT_ADDRESSES, ABIS } from '../config/contracts';
import { ACTIVE_NETWORK } from '../config/networks';

// Read-only fallback provider (used before connecting OR when on wrong chain)
const buildReadProvider = () => {
  return new ethers.providers.JsonRpcProvider(ACTIVE_NETWORK.rpcUrls[0]);
};

export const useContracts = () => {
  const { signer, provider, networkOk } = useWallet();

  return useMemo(() => {
    const writer = networkOk && signer ? signer : null;
    const reader = networkOk && provider ? provider : buildReadProvider();

    const make = (addr, abi) => {
      if (!addr || addr === '0x0000000000000000000000000000000000000000') return null;
      return {
        read:  new ethers.Contract(addr, abi, reader),
        write: writer ? new ethers.Contract(addr, abi, writer) : null
      };
    };

    return {
      plans:       make(CONTRACT_ADDRESSES.PLANS,        ABIS.PLANS),
      coreStorage: make(CONTRACT_ADDRESSES.CORE_STORAGE, ABIS.CORE_STORAGE),
      booster:     make(CONTRACT_ADDRESSES.BOOSTER,      ABIS.BOOSTER),
      usdt:        make(CONTRACT_ADDRESSES.USDT,         ABIS.ERC20)
    };
  }, [signer, provider, networkOk]);
};
